import { isString } from 'lodash';

export const normalizeCustomFields = (
  customFields: Record<string, string | string[]>,
): Record<string, string[]> => {
  return Object.entries(customFields || {}).reduce((acc, [key, value]) => {
    if (Array.isArray(value)) {
      acc[key] = value;
    } else if (isString(value)) {
      acc[key] = [value];
    } else {
      acc[key] = [];
    }

    return acc;
  }, {} as Record<string, string[]>);
};
